var a = (o, r, e) => new Promise((c, n) => {
  var p = (t) => {
    try {
      s(e.next(t));
    } catch (i) {
      n(i);
    }
  }, y = (t) => {
    try {
      s(e.throw(t));
    } catch (i) {
      n(i);
    }
  }, s = (t) => t.done ? c(t.value) : Promise.resolve(t.value).then(p, y);
  s((e = e.apply(o, r)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function u(o) {
  return a(this, null, function* () {
    const {
      data: r
    } = yield d.post(
      "/designordercenter/productionOrder/getEsPageListByQry",
      o
    );
    return r == null ? void 0 : r.data;
  });
}
export {
  u as postGetEsPageListByQry
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/getEsPageListByQry/post.js
// module id = 1814
// module chunks = 67